import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    addSoldToToSelected,
    removeSoldToFromSelected,
    clearSelectedInvoices,
    setSelectedSoldTos
} from '../../actions/InvoiceActions';
import { getSelectedPrimaryAccount } from "./Selectors";
import { getSoldToNames } from "../../requests/InvoiceRequests";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class SoldToSelectAll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allSelected: true
        };
        this.handleCustomerCheckChange = this.handleCustomerCheckChange.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
        // this.getSoldToDetailsForInvoices = this.getSoldToDetailsForInvoices.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.allSelected = this.allSelected.bind(this);
    }

    // componentDidMount(){
    //   this.getSoldToDetailsForInvoices();
    // }


    selectAll() {
        if (this.allSelected()) {
            this.props.dispatch(setSelectedSoldTos([]));
        } else {
            this.props.dispatch(setSelectedSoldTos(this.props.secondaryAccounts.map(s => s.PrimaryAcct)));
        }
    }

    allSelected() {
        return this.props.secondaryAccounts.length === this.props.selectedSoldTos.length;
    }


    handleCustomerCheckChange = (target) => {
        clearSelectedInvoices(this.props.dispatch);
        const value = target.currentTarget.id;
        const isChecked = target.currentTarget.checked;

        if (isChecked) {
            this.props.dispatch(addSoldToToSelected(value));
        } else {
            this.props.dispatch(removeSoldToFromSelected(value));
        }
    };

    getName(customer) {
        let name = "" + customer.PrimaryAcct;
        if (typeof customer.Name !== "undefined" && customer.Name !== null) {
            return name + " - " + customer.Name;
        }
        return name;
    }

    createSelectItems() {
        const account = this.props.selectedPrimaryAccount && this.props.selectedPrimaryAccount.PrimaryAcct ? this.props.selectedPrimaryAccount.PrimaryAcct : '';
        const selectedItems = this.props.selectedSoldTos;

        let items = [];
        for (let l = 0; l < this.props.secondaryAccounts.length; l += 1) {
            const customer = this.props.secondaryAccounts[l];

            let itemColor = 'checkbox checkbox-primary dropdown-item truncate ';
            let isChecked = '';
            if (selectedItems.indexOf(customer.PrimaryAcct) !== -1) {
                itemColor = 'checkbox checkbox-primary dropdown-item truncate multiSelectItemColor';
                isChecked = 'checked';
            }

            items.push(<li key={`li_${customer.PrimaryAcct}`}>
                <div className={itemColor} key={`div_${customer.PrimaryAcct}`}>
                    <label key={`lbl_${customer.PrimaryAcct}`} htmlFor={`lbl_${customer.PrimaryAcct}`}>
                        <input className="checkMargin" type="checkbox" key={`${account}${customer.PrimaryAcct}`} id={customer.PrimaryAcct} onChange={this.handleCustomerCheckChange} checked={isChecked} />{this.getName(customer)}
                    </label>
                </div>
            </li>);
        }

        return items;
    }

    render() {
        return (
            <div className="soldto-select customSelect">

                <button className="form-control soldToBtnColor btn-block dropdown-toggle  inline-block " id="soldToToggle" type="button" data-bs-toggle="dropdown" >
                    <span>{this.props.selectedSoldTos ? this.props.selectedSoldTos.length : 0} Customers Selected</span>
                    <span className="select-arrow">
                        <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"} />
                    </span>
                </button>
                <ul className="dropdown-menu">
                    <li>
                        <div className="checkbox checkbox-primary dropdown-item truncate multiSelectItemColor">
                            <label htmlFor={`lbl_ship_to_select_all`}>
                                <input className="checkMargin" type="checkbox" id="lbl_ship_to_select_all" onChange={this.selectAll} checked={this.allSelected()} />Select All
                            </label>
                        </div>
                    </li>
                    {this.createSelectItems()}
                </ul>
            </div>
        )}
}

SoldToSelectAll.propTypes = {
    dispatch: PropTypes.func.isRequired,
};
export default connect((store, props) => ({
    secondaryAccounts: store.user_options.secondaryAccounts,
    selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
    selectedSoldTos: store.user_options.selectedSoldTos,
    invoices: store.default.invoices,
}))(SoldToSelectAll);
